import { useTranslation } from 'react-i18next';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const { t } = useTranslation();
    const { currentUser, loading } = useAuth();

    if (loading) {
        return <div>{t('loading2')}</div>; // Ou un spinner pour indiquer le chargement
    }

    return currentUser ? <Navigate to="/dashboard" /> : children;
};

export default PublicRoute;
